import { useAgreementPermissions } from '../../hooks/useAgreementPermissions';
import { HasPermissionProps } from './types';

export function HasAgreementPermission({ id, permissions, children, fallback, partial = false }: HasPermissionProps) {
  const { isLoading, hasAnyPermission, hasPermission } = useAgreementPermissions({ id });
  if (!id) return null;
  if (isLoading) return null;
  if (partial ? !hasAnyPermission(permissions) : !hasPermission(permissions)) return fallback ? fallback : null;
  return <>{children}</>;
}
